import { Box } from '@mui/material';
import React from 'react';
import BaseVideo from 'components/video/BaseVideo';
import { useMediaQuery } from '@mui/system';
import BaseImage from 'components/image/BaseImage';
import appTheme from 'ui-blocks/AppTheme';
import { createImagineStyles } from '../createImagineStyles';

const baseUrl = `${process.env.REACT_APP_S3_BASE_URL}/29_april_revamp/character`;

const videoSources = [
	{
		id: 'character_video_1',
		src: `${baseUrl}/character_video_1.mp4`,
		thumbnail: `${baseUrl}/thumbnail_character_video_1.webp`,
	},
	{
		id: 'character_video_2',
		src: `${baseUrl}/character_video_2.mp4`,
		thumbnail: `${baseUrl}/thumbnail_character_video_2.webp`,
	},
	{
		id: 'character_video_3',
		src: `${baseUrl}/character_video_3.mp4`,
		thumbnail: `${baseUrl}/thumbnail_character_video_3.webp`,
	},
];

export default function CreateImagineVideos() {
	const isMobile = useMediaQuery(appTheme.breakpoints.down('smTab'));
	return (
		<Box sx={{ position: 'relative', width: { xs: '100%', mobileUi: '75%', xxl: '65%' } }}>
			<Box id="create-imagine-image" sx={[createImagineStyles.imageContainer]}>
				<BaseImage
					src={`${baseUrl}/character_face.webp`}
					style={{
						...createImagineStyles.baseImage,
					}}
					alt="create imagine image"
				/>
			</Box>
			<Box id="create-imagine-video-container" sx={[createImagineStyles.videoContainer]}>
				{videoSources.map((video, index) => (
					<Box key={`hero-video-${video.id}`} sx={{ flex: 1 }}>
						<BaseVideo
							id={`hero-video-${index}`}
							src={video.src}
							poster={video.thumbnail}
							controls={false}
							autoPlay
							muted
							loop
							playPauseIcon={false}
							showSkeletonLoading
							playsInline
							style={{
								...createImagineStyles.baseVideo,
								borderRadius: isMobile ? '16px' : '32px',
							}}
							containerStyle={{
								aspectRatio: '0.55',
							}}
						/>
					</Box>
				))}
			</Box>
		</Box>
	);
}
